import {
  AppId,
  Collection,
  CollectionOrder,
  ContentGroups,
  CustomerPurchase,
  CustomerPurchaseEventsPage,
  CustomerPurchaseState,
  DiscountType,
  Episode,
  EpisodeType,
  Exact,
  Group,
  GroupsPage,
  LinearChannel,
  LinearSlot,
  MonetaryAmount,
  Movie,
  NamedFilter,
  PayPerViewContent,
  Schedule,
  Show,
  ShowType,
  StandardAspectRatio,
} from '@skytvnz/sky-app-store/lib/types/graph-ql';

export declare type Maybe<T> = T | null;

/** All built-in and custom scalars, mapped to their actual values */
export declare type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  URI: any;
  URIPath: any;
  LocalDate: any;
  DateTime: any;
  DateTimeEpochMs: any;
  Duration: any;
  JSON: any;
  Void: any;
  Decimal: any;
  CurrencyCode: any;
  LanguageCode: any;
};

export type GetOfferDetailsQueryVariables = Exact<{
  appId: AppId;
  offerId: Scalars['ID']['input'];
}>;

export type GroupMember =
  | Collection
  | CollectionLink
  | Episode
  | LinearChannel
  | LinearSlot
  | Movie
  | Show;
export enum BillingFrequency {
  Monthly = 'MONTHLY',
}
export type ViewingMethods = VodViewingMethod & LinearViewingMethod;

export type GetOfferDetailsQuery = {
  __typename?: 'Query';
  experience: {
    __typename?: 'SkyExperience';
    customer: {
      __typename?: 'CustomerAccount';
      offer?: {
        __typename?: 'CustomerPackageOffer';
        id: string;
        title: string;
        synopsis: string;
        heroImage: { __typename?: 'Image'; uri: string };
        logoImages: Array<{ __typename?: 'Image'; uri: string } | null>;
        price: {
          __typename?: 'CustomerPackagePrice';
          billingFrequency: BillingFrequency;
          basePrice: { __typename?: 'MonetaryAmount'; amount: number };
          discount?: {
            __typename?: 'CustomerPackageDiscount';
            type: DiscountType;
            value: number;
            duration: string;
          } | null;
        };
        collectionLink?: {
          __typename?: 'CollectionLink';
          collection: { __typename?: 'Collection'; id: string; title: string };
        } | null;
        groupsPage: {
          groups: Array<
            | {
                __typename?: 'ContinueWatchingGroup';
                title?: string | null;
                aspectRatio: StandardAspectRatio;
                contentPage: {
                  __typename?: 'ContentPage';
                  content: Array<
                    | { __typename?: 'BoxApp' }
                    | {
                        __typename?: 'Collection';
                        id: string;
                        title: string;
                        tileImage: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'CollectionLink' }
                    | {
                        __typename?: 'Episode';
                        id: string;
                        type: EpisodeType;
                        title: string;
                        show: { __typename?: 'Show'; type: ShowType; id: string };
                        image: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'LinearChannel' }
                    | { __typename?: 'LinearSlot' }
                    | {
                        __typename?: 'Movie';
                        title: string;
                        id: string;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | { __typename?: 'PayPerViewEvent' }
                    | { __typename?: 'SectionLink' }
                    | {
                        __typename?: 'Show';
                        id: string;
                        title: string;
                        contentType: ShowType;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | null
                  >;
                  pageInfo: {
                    __typename?: 'PageInfo';
                    hasNextPage: boolean;
                    hasPreviousPage: boolean;
                    startCursor?: string | null;
                    endCursor?: string | null;
                  };
                };
              }
            | {
                __typename?: 'FavouriteAppsGroup';
                title?: string | null;
                aspectRatio: StandardAspectRatio;
                contentPage: {
                  __typename?: 'ContentPage';
                  content: Array<
                    | { __typename?: 'BoxApp' }
                    | {
                        __typename?: 'Collection';
                        id: string;
                        title: string;
                        tileImage: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'CollectionLink' }
                    | {
                        __typename?: 'Episode';
                        id: string;
                        type: EpisodeType;
                        title: string;
                        show: { __typename?: 'Show'; type: ShowType; id: string };
                        image: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'LinearChannel' }
                    | { __typename?: 'LinearSlot' }
                    | {
                        __typename?: 'Movie';
                        title: string;
                        id: string;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | { __typename?: 'PayPerViewEvent' }
                    | { __typename?: 'SectionLink' }
                    | {
                        __typename?: 'Show';
                        id: string;
                        title: string;
                        contentType: ShowType;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | null
                  >;
                  pageInfo: {
                    __typename?: 'PageInfo';
                    hasNextPage: boolean;
                    hasPreviousPage: boolean;
                    startCursor?: string | null;
                    endCursor?: string | null;
                  };
                };
              }
            | {
                __typename?: 'FeatureRailGroup';
                title?: string | null;
                aspectRatio: StandardAspectRatio;
                contentPage: {
                  __typename?: 'ContentPage';
                  content: Array<
                    | { __typename?: 'BoxApp' }
                    | {
                        __typename?: 'Collection';
                        id: string;
                        title: string;
                        tileImage: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'CollectionLink' }
                    | {
                        __typename?: 'Episode';
                        id: string;
                        type: EpisodeType;
                        title: string;
                        show: { __typename?: 'Show'; type: ShowType; id: string };
                        image: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'LinearChannel' }
                    | { __typename?: 'LinearSlot' }
                    | {
                        __typename?: 'Movie';
                        title: string;
                        id: string;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | { __typename?: 'PayPerViewEvent' }
                    | { __typename?: 'SectionLink' }
                    | {
                        __typename?: 'Show';
                        id: string;
                        title: string;
                        contentType: ShowType;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | null
                  >;
                  pageInfo: {
                    __typename?: 'PageInfo';
                    hasNextPage: boolean;
                    hasPreviousPage: boolean;
                    startCursor?: string | null;
                    endCursor?: string | null;
                  };
                };
              }
            | {
                __typename?: 'GridGroup';
                title?: string | null;
                aspectRatio: StandardAspectRatio;
                contentPage: {
                  __typename?: 'ContentPage';
                  content: Array<
                    | { __typename?: 'BoxApp' }
                    | {
                        __typename?: 'Collection';
                        id: string;
                        title: string;
                        tileImage: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'CollectionLink' }
                    | {
                        __typename?: 'Episode';
                        id: string;
                        type: EpisodeType;
                        title: string;
                        show: { __typename?: 'Show'; type: ShowType; id: string };
                        image: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'LinearChannel' }
                    | { __typename?: 'LinearSlot' }
                    | {
                        __typename?: 'Movie';
                        title: string;
                        id: string;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | { __typename?: 'PayPerViewEvent' }
                    | { __typename?: 'SectionLink' }
                    | {
                        __typename?: 'Show';
                        id: string;
                        title: string;
                        contentType: ShowType;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | null
                  >;
                  pageInfo: {
                    __typename?: 'PageInfo';
                    hasNextPage: boolean;
                    hasPreviousPage: boolean;
                    startCursor?: string | null;
                    endCursor?: string | null;
                  };
                };
              }
            | {
                __typename?: 'LandscapeRailGroup';
                title?: string | null;
                aspectRatio: StandardAspectRatio;
                contentPage: {
                  __typename?: 'ContentPage';
                  content: Array<
                    | { __typename?: 'BoxApp' }
                    | {
                        __typename?: 'Collection';
                        id: string;
                        title: string;
                        tileImage: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'CollectionLink' }
                    | {
                        __typename?: 'Episode';
                        id: string;
                        type: EpisodeType;
                        title: string;
                        show: { __typename?: 'Show'; type: ShowType; id: string };
                        image: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'LinearChannel' }
                    | { __typename?: 'LinearSlot' }
                    | {
                        __typename?: 'Movie';
                        title: string;
                        id: string;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | { __typename?: 'PayPerViewEvent' }
                    | { __typename?: 'SectionLink' }
                    | {
                        __typename?: 'Show';
                        id: string;
                        title: string;
                        contentType: ShowType;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | null
                  >;
                  pageInfo: {
                    __typename?: 'PageInfo';
                    hasNextPage: boolean;
                    hasPreviousPage: boolean;
                    startCursor?: string | null;
                    endCursor?: string | null;
                  };
                };
              }
            | {
                __typename?: 'LargeLandscapeRailGroup';
                title?: string | null;
                aspectRatio: StandardAspectRatio;
                contentPage: {
                  __typename?: 'ContentPage';
                  content: Array<
                    | { __typename?: 'BoxApp' }
                    | {
                        __typename?: 'Collection';
                        id: string;
                        title: string;
                        tileImage: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'CollectionLink' }
                    | {
                        __typename?: 'Episode';
                        id: string;
                        type: EpisodeType;
                        title: string;
                        show: { __typename?: 'Show'; type: ShowType; id: string };
                        image: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'LinearChannel' }
                    | { __typename?: 'LinearSlot' }
                    | {
                        __typename?: 'Movie';
                        title: string;
                        id: string;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | { __typename?: 'PayPerViewEvent' }
                    | { __typename?: 'SectionLink' }
                    | {
                        __typename?: 'Show';
                        id: string;
                        title: string;
                        contentType: ShowType;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | null
                  >;
                  pageInfo: {
                    __typename?: 'PageInfo';
                    hasNextPage: boolean;
                    hasPreviousPage: boolean;
                    startCursor?: string | null;
                    endCursor?: string | null;
                  };
                };
              }
            | {
                __typename?: 'LargeRailGroup';
                title?: string | null;
                aspectRatio: StandardAspectRatio;
                contentPage: {
                  __typename?: 'ContentPage';
                  content: Array<
                    | { __typename?: 'BoxApp' }
                    | {
                        __typename?: 'Collection';
                        id: string;
                        title: string;
                        tileImage: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'CollectionLink' }
                    | {
                        __typename?: 'Episode';
                        id: string;
                        type: EpisodeType;
                        title: string;
                        show: { __typename?: 'Show'; type: ShowType; id: string };
                        image: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'LinearChannel' }
                    | { __typename?: 'LinearSlot' }
                    | {
                        __typename?: 'Movie';
                        title: string;
                        id: string;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | { __typename?: 'PayPerViewEvent' }
                    | { __typename?: 'SectionLink' }
                    | {
                        __typename?: 'Show';
                        id: string;
                        title: string;
                        contentType: ShowType;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | null
                  >;
                  pageInfo: {
                    __typename?: 'PageInfo';
                    hasNextPage: boolean;
                    hasPreviousPage: boolean;
                    startCursor?: string | null;
                    endCursor?: string | null;
                  };
                };
              }
            | {
                __typename?: 'MediumRailGroup';
                title?: string | null;
                aspectRatio: StandardAspectRatio;
                contentPage: {
                  __typename?: 'ContentPage';
                  content: Array<
                    | { __typename?: 'BoxApp' }
                    | {
                        __typename?: 'Collection';
                        id: string;
                        title: string;
                        tileImage: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'CollectionLink' }
                    | {
                        __typename?: 'Episode';
                        id: string;
                        type: EpisodeType;
                        title: string;
                        show: { __typename?: 'Show'; type: ShowType; id: string };
                        image: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'LinearChannel' }
                    | { __typename?: 'LinearSlot' }
                    | {
                        __typename?: 'Movie';
                        title: string;
                        id: string;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | { __typename?: 'PayPerViewEvent' }
                    | { __typename?: 'SectionLink' }
                    | {
                        __typename?: 'Show';
                        id: string;
                        title: string;
                        contentType: ShowType;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | null
                  >;
                  pageInfo: {
                    __typename?: 'PageInfo';
                    hasNextPage: boolean;
                    hasPreviousPage: boolean;
                    startCursor?: string | null;
                    endCursor?: string | null;
                  };
                };
              }
            | {
                __typename?: 'OnAirSlotGroup';
                title?: string | null;
                aspectRatio: StandardAspectRatio;
                contentPage: {
                  __typename?: 'ContentPage';
                  content: Array<
                    | { __typename?: 'BoxApp' }
                    | {
                        __typename?: 'Collection';
                        id: string;
                        title: string;
                        tileImage: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'CollectionLink' }
                    | {
                        __typename?: 'Episode';
                        id: string;
                        type: EpisodeType;
                        title: string;
                        show: { __typename?: 'Show'; type: ShowType; id: string };
                        image: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'LinearChannel' }
                    | { __typename?: 'LinearSlot' }
                    | {
                        __typename?: 'Movie';
                        title: string;
                        id: string;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | { __typename?: 'PayPerViewEvent' }
                    | { __typename?: 'SectionLink' }
                    | {
                        __typename?: 'Show';
                        id: string;
                        title: string;
                        contentType: ShowType;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | null
                  >;
                  pageInfo: {
                    __typename?: 'PageInfo';
                    hasNextPage: boolean;
                    hasPreviousPage: boolean;
                    startCursor?: string | null;
                    endCursor?: string | null;
                  };
                };
              }
            | {
                __typename?: 'PortraitRailGroup';
                title?: string | null;
                aspectRatio: StandardAspectRatio;
                contentPage: {
                  __typename?: 'ContentPage';
                  content: Array<
                    | { __typename?: 'BoxApp' }
                    | {
                        __typename?: 'Collection';
                        id: string;
                        title: string;
                        tileImage: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'CollectionLink' }
                    | {
                        __typename?: 'Episode';
                        id: string;
                        type: EpisodeType;
                        title: string;
                        show: { __typename?: 'Show'; type: ShowType; id: string };
                        image: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'LinearChannel' }
                    | { __typename?: 'LinearSlot' }
                    | {
                        __typename?: 'Movie';
                        title: string;
                        id: string;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | { __typename?: 'PayPerViewEvent' }
                    | { __typename?: 'SectionLink' }
                    | {
                        __typename?: 'Show';
                        id: string;
                        title: string;
                        contentType: ShowType;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | null
                  >;
                  pageInfo: {
                    __typename?: 'PageInfo';
                    hasNextPage: boolean;
                    hasPreviousPage: boolean;
                    startCursor?: string | null;
                    endCursor?: string | null;
                  };
                };
              }
            | {
                __typename?: 'SmallLandscapeRailGroup';
                title?: string | null;
                aspectRatio: StandardAspectRatio;
                contentPage: {
                  __typename?: 'ContentPage';
                  content: Array<
                    | { __typename?: 'BoxApp' }
                    | {
                        __typename?: 'Collection';
                        id: string;
                        title: string;
                        tileImage: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'CollectionLink' }
                    | {
                        __typename?: 'Episode';
                        id: string;
                        type: EpisodeType;
                        title: string;
                        show: { __typename?: 'Show'; type: ShowType; id: string };
                        image: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'LinearChannel' }
                    | { __typename?: 'LinearSlot' }
                    | {
                        __typename?: 'Movie';
                        title: string;
                        id: string;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | { __typename?: 'PayPerViewEvent' }
                    | { __typename?: 'SectionLink' }
                    | {
                        __typename?: 'Show';
                        id: string;
                        title: string;
                        contentType: ShowType;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | null
                  >;
                  pageInfo: {
                    __typename?: 'PageInfo';
                    hasNextPage: boolean;
                    hasPreviousPage: boolean;
                    startCursor?: string | null;
                    endCursor?: string | null;
                  };
                };
              }
            | {
                __typename?: 'SmallRailGroup';
                title?: string | null;
                aspectRatio: StandardAspectRatio;
                contentPage: {
                  __typename?: 'ContentPage';
                  content: Array<
                    | { __typename?: 'BoxApp' }
                    | {
                        __typename?: 'Collection';
                        id: string;
                        title: string;
                        tileImage: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'CollectionLink' }
                    | {
                        __typename?: 'Episode';
                        id: string;
                        type: EpisodeType;
                        title: string;
                        show: { __typename?: 'Show'; type: ShowType; id: string };
                        image: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'LinearChannel' }
                    | { __typename?: 'LinearSlot' }
                    | {
                        __typename?: 'Movie';
                        title: string;
                        id: string;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | { __typename?: 'PayPerViewEvent' }
                    | { __typename?: 'SectionLink' }
                    | {
                        __typename?: 'Show';
                        id: string;
                        title: string;
                        contentType: ShowType;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | null
                  >;
                  pageInfo: {
                    __typename?: 'PageInfo';
                    hasNextPage: boolean;
                    hasPreviousPage: boolean;
                    startCursor?: string | null;
                    endCursor?: string | null;
                  };
                };
              }
            | {
                __typename?: 'TvGuideRailGroup';
                title?: string | null;
                aspectRatio: StandardAspectRatio;
                contentPage: {
                  __typename?: 'ContentPage';
                  content: Array<
                    | { __typename?: 'BoxApp' }
                    | {
                        __typename?: 'Collection';
                        id: string;
                        title: string;
                        tileImage: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'CollectionLink' }
                    | {
                        __typename?: 'Episode';
                        id: string;
                        type: EpisodeType;
                        title: string;
                        show: { __typename?: 'Show'; type: ShowType; id: string };
                        image: { __typename?: 'Image'; uri: string };
                      }
                    | { __typename?: 'LinearChannel' }
                    | { __typename?: 'LinearSlot' }
                    | {
                        __typename?: 'Movie';
                        title: string;
                        id: string;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | { __typename?: 'PayPerViewEvent' }
                    | { __typename?: 'SectionLink' }
                    | {
                        __typename?: 'Show';
                        id: string;
                        title: string;
                        contentType: ShowType;
                        tileImage: {
                          __typename?: 'Image';
                          uri: string;
                          hasTitleTreatment: boolean;
                        };
                      }
                    | null
                  >;
                  pageInfo: {
                    __typename?: 'PageInfo';
                    hasNextPage: boolean;
                    hasPreviousPage: boolean;
                    startCursor?: string | null;
                    endCursor?: string | null;
                  };
                };
              }
            | null
          >;
        };
      } | null;
    };
  };
};

export declare type SectionHome = {
  __typename: string;
  path: string;
  section: Section;
};
export declare enum OverlayPosition {
  TopLeft = 'TOP_LEFT',
  TopRight = 'TOP_RIGHT',
  Center = 'CENTER',
  BottomLeft = 'BOTTOM_LEFT',
  BottomRight = 'BOTTOM_RIGHT',
}
export declare type OverlayImage = {
  __typename?: 'OverlayImage';
  uri: Scalars['URI'];
  position: OverlayPosition;
};
export declare type Image = {
  __typename?: 'Image';
  uri: Scalars['URI'];
  /** @Beta This is experimental version and subject to change in future */
  overlayImages: Array<OverlayImage>;
};
export declare enum SectionNavAlignment {
  Top = 'TOP',
  Bottom = 'BOTTOM',
}
export declare enum PredefinedSectionId {
  Home = 'HOME',
  Browse = 'BROWSE',
  MyApps = 'MY_APPS',
  MyHub = 'MY_HUB',
  TvGuide = 'TV_GUIDE',
  WatchTv = 'WATCH_TV',
  Planner = 'PLANNER',
}
export declare type Section = {
  __typename?: 'Section';
  id: Scalars['ID'];
  /** Not all sections have a predefined id, eg "Sports" home page */
  predefinedId?: Maybe<PredefinedSectionId>;
  icon: Image;
  heroImage: Image;
  title: Scalars['String'];
  /**  Descriptive/promotional text for a section  */
  synopsis?: Maybe<Scalars['String']>;
  /**  eg 'Say "TV Guide" on your remote"  */
  voiceHint?: Maybe<Scalars['String']>;
  home: SectionHome;
  alignment: SectionNavAlignment;
};

export type CustomerDuplicatePurchaseError = {
  __typename?: 'CustomerDuplicatePurchaseError';
  existingPurchase: CustomerPurchase;
};

export type CustomerLinearPayPerViewPurchase = CustomerPurchase & {
  __typename?: 'CustomerLinearPayPerViewPurchase';
  /**
   * The device this purchase is tied to, if any
   * @deprecated retained only for backward compatibility.
   */
  deviceId?: Maybe<Scalars['ID']['output']>;
  events: CustomerPurchaseEventsPage;
  id: Scalars['ID']['output'];
  offer: CustomerPayPerViewOffer;
  purchasedAt: Scalars['DateTime']['output'];
  state: CustomerPurchaseState;
};

export type CustomerLinearPayPerViewPurchaseEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerNotification = {
  /**
   * A "consumed" notification is one that has been marked as actioned or read by a profile,
   * and is retained only for traceability, potentially only for a limited amount of time.
   */
  consumed: Scalars['Boolean']['output'];
  consumedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /**  When the notification was triggered  */
  sentAt: Scalars['DateTime']['output'];
};

/**  A packaged product, eg "Sky Entertainment"  */
export type CustomerPackage = {
  __typename?: 'CustomerPackage';
  id: Scalars['ID']['output'];
  image: Image;
  /**  null if the customer doesn't have a current subscription to this package  */
  mySubscription?: Maybe<CustomerPackageSubscription>;
  /**  null if this package is not available for purchase  */
  offer?: Maybe<CustomerPackageOffer>;
  title: Scalars['String']['output'];
};

export type CustomerPackageDiscount = {
  __typename?: 'CustomerPackageDiscount';
  /**  ISO 8601 duration string */
  duration: Scalars['Duration']['output'];
  type: DiscountType;
  value: Scalars['Decimal']['output'];
};

/**  A promotion of a package that is available for purchase. */
export type CustomerPackageOffer = ContentGroups & {
  __typename?: 'CustomerPackageOffer';
  collectionLink?: Maybe<CollectionLink>;
  /**  Returns null if the group is not found  */
  group?: Maybe<Group>;
  groups: Array<Maybe<Group>>;
  groupsPage: GroupsPage;
  heroImage: Image;
  id: Scalars['ID']['output'];
  logoImages: Array<Maybe<Image>>;
  package: CustomerPackage;
  path: Scalars['URIPath']['output'];
  price: CustomerPackagePrice;
  synopsis: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/**  A promotion of a package that is available for purchase. */
export type CustomerPackageOfferGroupArgs = {
  id: Scalars['ID']['input'];
};

/**  A promotion of a package that is available for purchase. */
export type CustomerPackageOfferGroupsPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerPackagePrice = {
  __typename?: 'CustomerPackagePrice';
  basePrice: MonetaryAmount;
  billingFrequency: BillingFrequency;
  discount?: Maybe<CustomerPackageDiscount>;
};

/**  A subscription of a customer to a package  */
export type CustomerPackageSubscription = {
  __typename?: 'CustomerPackageSubscription';
  package: CustomerPackage;
  price: CustomerPackageSubscriptionPrice;
};

export type CustomerPackageSubscriptionPrice = {
  __typename?: 'CustomerPackageSubscriptionPrice';
  basePrice: MonetaryAmount;
  billingFrequency: BillingFrequency;
};

/**  @deprecated, CustomerDuplicatePurchaseError will be returned  */
export type CustomerPayPerViewDuplicatePurchaseError = {
  __typename?: 'CustomerPayPerViewDuplicatePurchaseError';
  existingPurchase: CustomerLinearPayPerViewPurchase;
};

export type CustomerPayPerViewOffer = {
  __typename?: 'CustomerPayPerViewOffer';
  content: Array<PayPerViewContent>;
  id: Scalars['ID']['output'];
  price: MonetaryAmount;
  purchases: Array<CustomerLinearPayPerViewPurchase>;
  schedules: Array<Schedule>;
  slots: Array<LinearSlot>;
};

export type CustomerPayPerViewOfferPurchasesArgs = {
  state?: InputMaybe<Array<CustomerPurchaseState>>;
};

export enum CustomerPayPerViewOfferFilter {
  All = 'ALL',
  AvailableToPurchase = 'AVAILABLE_TO_PURCHASE',
}

export type PkgsListProps = {
  topItemRefName: string;
  selectedTabId: string;
  onItemSelected: (item: CustomerPackageSubscription | CustomerPackageOffer | null) => void;
  testID: string;
};

export type CollectionLink = {
  __typename?: 'CollectionLink';
  collection: Collection;
  /**  If present, named filters that should be applied by the client when this collection is opened from this link  */
  namedFilters: Array<NamedFilter>;
  /**  If present, sort that should be applied by the client when this collectin is opened  */
  sort?: Maybe<CollectionOrder>;
  tileImage: Image;
};
export type DateRange = {
  __typename?: 'DateRange';
  end?: Maybe<Scalars['DateTime']['output']>;
  start: Scalars['DateTime']['output'];
};
/**  Watch content airing on a linear channel  */
export type LinearViewingMethod = ViewingMethod & {
  __typename?: 'LinearViewingMethod';
  _?: Maybe<Scalars['Void']['output']>;
  /**  If the package list is empty, it means there's no subscription required to watch i.e. free-to-air.  */
  packages: Array<Maybe<CustomerPackage>>;
};

/**  Watch content on-demand  */
export type VodViewingMethod = ViewingMethod & {
  __typename?: 'VodViewingMethod';
  _?: Maybe<Scalars['Void']['output']>;
  dateRange: DateRange;
  /**  If the package list is empty, it means there's no subscription required to watch i.e. free-to-air.  */
  packages: Array<Maybe<CustomerPackage>>;
};
/**  A way to view content on the platform  */
export type ViewingMethod = {
  _?: Maybe<Scalars['Void']['output']>;
};

export type GetSubscribedPackagesQuery = {
  __typename?: 'Query';
  experience: {
    __typename?: 'SkyExperience';
    customer: {
      __typename?: 'CustomerAccount';
      packages: Array<{
        __typename?: 'CustomerPackageSubscription';
        package: {
          __typename?: 'CustomerPackage';
          id: string;
          image: { __typename?: 'Image'; uri: string };
        };
      } | null>;
    };
  };
};
export type GetUnSubscribedPkgsWithOfferDetailsQueryVariables = Exact<{
  appId: AppId;
}>;
export type GetUnSubscribedPkgsWithOfferDetailsQuery = {
  __typename?: 'Query';
  experience: {
    __typename?: 'SkyExperience';
    customer: {
      __typename?: 'CustomerAccount';
      offers: Array<{
        __typename?: 'CustomerPackageOffer';
        id: string;
        title: string;
        synopsis: string;
        heroImage: { __typename?: 'Image'; uri: string };
        price: {
          __typename?: 'CustomerPackagePrice';
          billingFrequency: BillingFrequency;
          basePrice: { __typename?: 'MonetaryAmount'; amount: number };
          discount?: {
            __typename?: 'CustomerPackageDiscount';
            type: DiscountType;
            value: number;
            duration: string;
          } | null;
        };
        collectionLink?: {
          __typename?: 'CollectionLink';
          collection: { __typename?: 'Collection'; id: string; title: string };
        } | null;
        package: { __typename?: 'CustomerPackage'; image: { __typename?: 'Image'; uri: string } };
      } | null>;
    };
  };
};
export type GetActivePkgsWithDetailsQuery = {
  __typename?: 'Query';
  experience: {
    __typename?: 'SkyExperience';
    customer: {
      __typename?: 'CustomerAccount';
      packages: Array<{
        __typename?: 'CustomerPackageSubscription';
        package: {
          __typename?: 'CustomerPackage';
          title: string;
          image: { __typename?: 'Image'; uri: string };
          mySubscription?: {
            __typename?: 'CustomerPackageSubscription';
            price?: {
              __typename?: 'CustomerPackageSubscriptionPrice';
              billingFrequency: BillingFrequency;
              basePrice: { __typename?: 'MonetaryAmount'; amount: number };
            } | null;
          } | null;
        };
      } | null>;
    };
  };
};
export type GetActivePkgsWithDetailsQueryVariables = Exact<{
  appId: AppId;
}>;

export type CustomerSubscribedPkgEventSubscriptionSubscription = {
  __typename?: 'Subscription';
  customerAccount: {
    __typename?: 'CustomerAccountVersion';
    account?: {
      __typename?: 'CustomerAccount';
      packages: Array<{
        __typename?: 'CustomerPackageSubscription';
        package: {
          __typename?: 'CustomerPackage';
          id: string;
          image: { __typename?: 'Image'; uri: string };
        };
      } | null>;
    } | null;
  };
};
